/**
 * @generated SignedSource<<2bdc8c1ef2244da2003f473c72c40ac7>>
 * @relayHash dedc8e6c065a9aeaded02c0c0972dbea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83313330b2730a0a6317628befcb1e3fded183e549e6e10a021d06fe037e064d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessOverviewTimelineQuery } from './src_jiraBusinessOverviewTimelineQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessOverviewTimelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "83313330b2730a0a6317628befcb1e3fded183e549e6e10a021d06fe037e064d",
    "metadata": {},
    "name": "src_jiraBusinessOverviewTimelineQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
